module.exports = __webpack_public_path__ + "img/ChinaUnicom.a359780e.png";